export default __webpack_public_path__ + "static/media/english-to-thai-screenshot-02.65cbe0f6.png";